import { isNull } from "App/utils/helpers";
import { useContext, useEffect, useState } from "react";
import { useMutation } from "react-query";
import { FormContext } from "../../context/FormContext";
import { getAllPaketByKelas } from "../TabPaket/DaftarPaket/helpers";
import { itSelfEmpty } from "utils/all";

const RESET_STATE_FORM_FILTER_JASA = {
  pages: 1,
  limit: 10,
  kelas_id: "",
  asuransi_id: "",
  name: "",
};

const refetchPaketByKelas = async (variables) => {
  if (
    !isNull(variables.kelas_id) &&
    !isNull(variables.asuransi_id) &&
    !isNull(variables.id_gudang)
  ) {
    const response = await getAllPaketByKelas(
      {
        kelas_id: variables.kelas_id,
        asuransi_id: variables.asuransi_id,
        name: variables.name,
        id_gudang: variables.id_gudang,
      },
      variables.pages,
      variables.limit
    );
    return {
      data: response.data,
      meta: response.meta,
    };
  } else {
    return {
      data: [],
      meta: {
        count: 0,
        pages: 1,
        limit: 10,
      },
    };
  }
};

export const useDaftarPaketByKelas = () => {
  const { formData } = useContext(FormContext);
  const [formFilterPaketByKelas, setFormFilterPaketByKelas] = useState(
    RESET_STATE_FORM_FILTER_JASA
  );

  const pakets = useMutation({
    mutationFn: (variables) => {
      return refetchPaketByKelas(variables);
    },
  });

  const rowsPaketByKelas = isNull(pakets.data) ? [] : pakets.data.data;
  const totalDataPaketByKelas = isNull(pakets.data)
    ? 0
    : pakets.data.meta.count;
  const loadingPaketByKelas = pakets.isLoading;

  const setNewDataPaketByKelas = (
    pages = formFilterPaketByKelas.pages,
    limit = formFilterPaketByKelas.limit,
    formFilter = formFilterPaketByKelas
  ) => {
    pakets.mutate({
      pages,
      limit,
      kelas_id: formData.kelas_id,
      asuransi_id: formData.asuransi_id,
      name: formFilter.name,
      id_gudang: itSelfEmpty(formData.gudang_id),
    });
  };

  useEffect(() => {
    (async () => {
      await setNewDataPaketByKelas();
    })();
  }, [formData.gudang_id, formData.kelas_id, formData.asuransi_id ]); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    loadingPaketByKelas,
    setNewDataPaketByKelas,
    rowsPaketByKelas,
    totalDataPaketByKelas,
    formFilterPaketByKelas,
    setFormFilterPaketByKelas,
  };
};
